/**
 * api接口的统一出口
 */

// 登录登出模块接口
import login from './login'
// 主页模块接口
import home from './home'
// 统计模块接口
import sum from './adminSum/index'
// 系统管理模块接口
import dictionary from './system/dataDictionary'
import school from './system/schoolInformation'
import log from './system/sysLog'
import sysFunction from './system/sysFunction'
import organization from './system/organization'
import semester from './system/semester'
// 权限管理模块接口
import role from './jurisdiction/role'
import user from './jurisdiction/user'
import exp from './jurisdiction/expAuthority'
import eva from './jurisdiction/evaluparams'

// 门户管理模块接口
import BaseFeedback from './door/feedback'
import baseNewsinfo from './door/baseNewsinfo'

// 用户模块接口
import userinfo from './user/SaveUser'

//管理中心
import testExamine from './management/testExamine'
import steps from './system/steps'

// 导出接口
export default {
  login,
  home,
  sum,
  dictionary,
  school,
  role,
  user,
  exp,
  eva,
  log,
  sysFunction,
  organization,
  BaseFeedback,
  baseNewsinfo,
  userinfo,
  testExamine,
  semester,
  steps
}
